<template lang='pug'>
.md-layout
  v-row(no-gutters style='padding: 0')
    v-col(xs='12' md='3')
      div(style='padding: 0 32px 16px 32px; width: 100%;')
        .titleLabel.colorDark(style='margin-top: 12px;')
          | {{$t('editInformation.importType')}}
        .textLabel.colorGrey {{$t('editInformation.mandatory')}}
        md-field
          label(for="importType") {{$t('editInformation.howWillItBeImported')}}
          md-select(
            name="importType"
            id="importType"
            v-model='snapshotEditData.importType'
            :disabled='importSimplifiedEditing'
            style='background-color: rgb(244, 244, 244); padding-left: 4px;')
            md-option(value='archived') {{$t('editInformation.filed')}}
            md-option(value='checkedout') Checkout
    v-col(xs='12' md='9')
      div(style='padding: 0 32px 16px 32px; width: 100%;')
        .titleLabel.colorDark(style='margin-top: 12px;')
          | {{$t('editInformation.versionDescription')}}
        .textLabel.colorGrey {{$t('editInformation.optional')}}
        md-field
          md-input(
            style='background-color: rgb(244, 244, 244); padding-left: 4px;'
            v-model='snapshotEditData.description'
            :placeholder="$t('editInformation.addEditTheDescriptionForThisVersion')"
          )
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditInformation',
  props: {
    snapshot: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  created () {
    let isImportSimplifiedEditing = this.$store.getters['snapshots/importSimplifiedEditing']
    if (isImportSimplifiedEditing) {
      this.snapshotEditData.importType = 'checkedout'
    }
  },
  computed: {
    snapshotType () {
      return this.snapshotEditData.importType
    },
    ...mapGetters('snapshots', {
      importSimplifiedEditing: 'importSimplifiedEditing'
    })
  },
  methods: {
    updateDescription (currentSnap, lastSnap) {
      if (
        !lastSnap?._source?.description ||
        lastSnap?._source?.description === this.snapshotEditData.description
      ) {
        this.snapshotEditData.description = currentSnap?._source?.description
      }
    }
  },
  watch: {
    snapshotType (newV) {
      if (newV !== null) {
        this.$emit('selected-type', this.snapshotEditData)
      }
    },
    snapshot: 'updateDescription'
  },
  data () {
    return {
      snapshotEditData: {
        description: '',
        importType: null
      }
    }
  }
}
</script>
